import React from 'react';
import PropTypes, { any } from 'prop-types';

import PickleballRangeScale from '../../../../components/PickleballRangeScale';
import RangeFilter from './CoreComponents/RangeFilter';
import { ratingTypes } from '../../../../utils/constants';

const PickleballRatingFilter = (props) => {
    const { filterInputs, handleOnRatingChange, 'data-testid': dataTestId } = props;

    const utrRangeDisplay = (min, max) => {
        return `${min.toFixed(1)} - ${max.toFixed(1)}`;
    };

    const minRange = filterInputs.ratingMin;
    const maxRange = filterInputs.ratingMax;

    return (
        <>
            <RangeFilter
                title={`${ratingTypes.pickleball} Range`}
                rangeKeyMin={1}
                rangeKeyMax={10}
                defaultValueArr={[minRange, maxRange]}
                min={minRange}
                max={maxRange}
                onChange={handleOnRatingChange}
                customRangeDisplay={utrRangeDisplay}
                isHalfSteps
                isPickleballRangeFilter
                data-testid={dataTestId}
            />
            <PickleballRangeScale />
        </>
    );
};

PickleballRatingFilter.propTypes = {
    filterInputs: PropTypes.objectOf(any).isRequired,
    handleOnRatingChange: PropTypes.func,
    'data-testid': PropTypes.string,
};
PickleballRatingFilter.defaultProps = {
    handleOnRatingChange: () => { },
    'data-testid': undefined,
};

export default PickleballRatingFilter;
